import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.width,
    height: _ctx.height,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("circle", {
      cx: "14",
      cy: "14",
      r: "10.3125",
      stroke: "#9AA4AE",
      "stroke-width": "1.375",
      class: "border"
    }, null, -1)),
    _createElementVNode("circle", {
      cx: "14",
      cy: "11.7084",
      r: "2.97917",
      stroke: _ctx.fill,
      "stroke-width": "1.375"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M6.66663 21.3333C7.98721 18.0775 10.7748 15.8333 14 15.8333C17.2252 15.8333 20.0127 18.0775 21.3333 21.3333",
      stroke: _ctx.fill,
      "stroke-width": "1.375"
    }, null, 8, _hoisted_3)
  ], 8, _hoisted_1))
}